module.exports = __webpack_public_path__ + "img/rmvb.e431df36.png";